module.exports = __webpack_public_path__ + "img/ciaz-2023.5a23c7f8.png";